/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_DunningCockpitDetailResponse } from '../models/billing_DunningCockpitDetailResponse';
import type { billing_DunningCockpitItemResponse } from '../models/billing_DunningCockpitItemResponse';
import type { billing_DunningCockpitListResponse } from '../models/billing_DunningCockpitListResponse';
import type { billing_DunningStageTotalsResponse } from '../models/billing_DunningStageTotalsResponse';
import type { billing_OptionalReasonRequest } from '../models/billing_OptionalReasonRequest';
import type { billing_PauseRequest } from '../models/billing_PauseRequest';
import type { billing_ReasonRequest } from '../models/billing_ReasonRequest';
import type { billing_RetrySendResponse } from '../models/billing_RetrySendResponse';
import type { billing_UpdateDunningTemplateRequest } from '../models/billing_UpdateDunningTemplateRequest';
import type { models_DunningTemplate } from '../models/models_DunningTemplate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DunningService {
    /**
     * List dunning templates
     * Returns the org's active dunning templates (one per stage × language).
     * @returns models_DunningTemplate OK
     * @throws ApiError
     */
    public static getApiV1DunningTemplates(): CancelablePromise<Array<models_DunningTemplate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dunning/templates',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a dunning template
     * Returns the per-org template for (stage, language). Falls back to the embedded default with is_default=true when no per-org row exists.
     * @param stage Stage
     * @param language Language
     * @returns models_DunningTemplate OK
     * @throws ApiError
     */
    public static getApiV1DunningTemplates1(
        stage: 'reminder_1' | 'reminder_2' | 'reminder_3' | 'final_notice' | 'final_repeat',
        language: 'en' | 'de',
    ): CancelablePromise<models_DunningTemplate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dunning/templates/{stage}/{language}',
            path: {
                'stage': stage,
                'language': language,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a dunning template
     * Persists a per-org override for (stage, language). Body HTML is sanitised first (script tags + on* attrs stripped); when body_text is omitted or blank, the server derives it from the sanitised HTML. is_default is forced to false.
     * @param stage Stage
     * @param language Language
     * @param request Update payload
     * @returns models_DunningTemplate OK
     * @throws ApiError
     */
    public static putApiV1DunningTemplates(
        stage: 'reminder_1' | 'reminder_2' | 'reminder_3' | 'final_notice' | 'final_repeat',
        language: 'en' | 'de',
        request: billing_UpdateDunningTemplateRequest,
    ): CancelablePromise<models_DunningTemplate> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/dunning/templates/{stage}/{language}',
            path: {
                'stage': stage,
                'language': language,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Reset a dunning template to default
     * Soft-deletes the per-org row so the renderer falls back to the embedded default. The response carries the embedded default content with is_default=true.
     * @param stage Stage
     * @param language Language
     * @returns models_DunningTemplate OK
     * @throws ApiError
     */
    public static postApiV1DunningTemplatesReset(
        stage: 'reminder_1' | 'reminder_2' | 'reminder_3' | 'final_notice' | 'final_repeat',
        language: 'en' | 'de',
    ): CancelablePromise<models_DunningTemplate> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/dunning/templates/{stage}/{language}/reset',
            path: {
                'stage': stage,
                'language': language,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List dunning workflow cockpit items
     * Paginated, sortable, filterable list of every dunning workflow in the org.
     * @param stage Comma-separated dunning stages (current|reminder_1_sent|...)
     * @param search Substring match on household name (max 100 chars)
     * @param sort Sort key (next_due_at|last_sent_at|outstanding|household_name|current_state)
     * @param order Sort order (asc|desc)
     * @param limit Page size (1-100, default 20)
     * @param offset Page offset (default 0)
     * @returns billing_DunningCockpitListResponse OK
     * @throws ApiError
     */
    public static getApiV1DunningWorkflows(
        stage?: string,
        search?: string,
        sort?: string,
        order?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<billing_DunningCockpitListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dunning/workflows',
            query: {
                'stage': stage,
                'search': search,
                'sort': sort,
                'order': order,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a dunning cockpit drawer payload
     * Returns the full drawer payload: header, open invoices, joined timeline, settings snapshot, and FSM-derived available actions.
     * @param id Workflow item ID
     * @returns billing_DunningCockpitDetailResponse OK
     * @throws ApiError
     */
    public static getApiV1DunningWorkflows1(
        id: string,
    ): CancelablePromise<billing_DunningCockpitDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dunning/workflows/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Cancel a dunning workflow
     * @param id Workflow item ID
     * @param request Reason body (optional for awaiting_approval cancel-this-email; required for FSM cancel)
     * @returns billing_DunningCockpitItemResponse OK
     * @throws ApiError
     */
    public static postApiV1DunningWorkflowsCancel(
        id: string,
        request?: billing_OptionalReasonRequest,
    ): CancelablePromise<billing_DunningCockpitItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/dunning/workflows/{id}/cancel',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Rate limit exceeded`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Mark a dunning workflow as collections handover
     * @param id Workflow item ID
     * @param request Reason body
     * @returns billing_DunningCockpitItemResponse OK
     * @throws ApiError
     */
    public static postApiV1DunningWorkflowsHandover(
        id: string,
        request: billing_ReasonRequest,
    ): CancelablePromise<billing_DunningCockpitItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/dunning/workflows/{id}/handover',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Rate limit exceeded`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Download the dunning letter as PDF
     * One A4 letter for the household of a dunning workflow, for households without an e-mail address (#2008). It prints the draft under review when the item awaits approval, else the blocked stage (or the next stage) rendered with the same template and tokens as the e-mail. Downloading does not send anything and does not advance the stage.
     * @param id Workflow item ID
     * @returns binary PDF file
     * @throws ApiError
     */
    public static getApiV1DunningWorkflowsLetterPdf(
        id: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dunning/workflows/{id}/letter-pdf',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `DUNNING_NO_LETTER_DUE: the workflow is closed or no further stage is enabled`,
                500: `Internal Server Error`,
                503: `Service Unavailable`,
            },
        });
    }
    /**
     * Pause a dunning workflow
     * @param id Workflow item ID
     * @param request Pause body
     * @returns billing_DunningCockpitItemResponse OK
     * @throws ApiError
     */
    public static postApiV1DunningWorkflowsPause(
        id: string,
        request: billing_PauseRequest,
    ): CancelablePromise<billing_DunningCockpitItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/dunning/workflows/{id}/pause',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Rate limit exceeded`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Resume a paused dunning workflow
     * @param id Workflow item ID
     * @param request Reason body
     * @returns billing_DunningCockpitItemResponse OK
     * @throws ApiError
     */
    public static postApiV1DunningWorkflowsResume(
        id: string,
        request: billing_ReasonRequest,
    ): CancelablePromise<billing_DunningCockpitItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/dunning/workflows/{id}/resume',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Rate limit exceeded`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Retry a blocked dunning send (inline)
     * Re-attempts a dunning send for a workflow item that has a blocker.
     * For no_recipient blockers, re-resolves the recipient and queues + drains inline.
     * For send_failed blockers, resets the failed outbox row to pending and drains inline.
     * For suppressed blockers, returns 409 with code change_email_to_recover.
     * @param id Workflow item ID
     * @returns billing_RetrySendResponse OK
     * @throws ApiError
     */
    public static postApiV1DunningWorkflowsRetry(
        id: string,
    ): CancelablePromise<billing_RetrySendResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/dunning/workflows/{id}/retry',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Rate limit exceeded`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send the next reminder immediately
     * @param id Workflow item ID
     * @param request Reason body (reason is optional)
     * @returns billing_DunningCockpitItemResponse OK
     * @throws ApiError
     */
    public static postApiV1DunningWorkflowsSendNow(
        id: string,
        request?: billing_OptionalReasonRequest,
    ): CancelablePromise<billing_DunningCockpitItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/dunning/workflows/{id}/send-now',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Rate limit exceeded`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Count dunning workflows per stage
     * Number of dunning workflow items per FSM stage in one grouped count (#2193), every stage of the list filter present (zero when empty). Replaces one limit=1 list request per stage.
     * @returns billing_DunningStageTotalsResponse OK
     * @throws ApiError
     */
    public static getApiV1DunningWorkflowsStageTotals(): CancelablePromise<billing_DunningStageTotalsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dunning/workflows/stage-totals',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
